function MetaOverview() {
    /// <summary>
    /// This object provides client-side functions for the Widget.Report.MetaOverview Visual. <br/>
    /// MetaOverview means you can get a live overview over the selected period in form of a table and a chart
    /// <br/>
    /// Author: MWI<br />
    /// Date: 21.09.2016<br />
    /// Copyright ©: EUDT GmbH 2016 <br />
    /// Version-History:<br />
    /// **********************************************************************<br />
    /// *** v1.0.0 - 12.05.2016                                               *<br />
    /// **********************************************************************<br />
    /// * - basic functionality                                              *<br />
    /// **********************************************************************<br />
    /// </summary>  
};
MetaOverview.prototype = new vcTemplate();

MetaOverview.prototype.init = function () {
    /// <summary>
    /// This function inits the the Object <br/>
    /// it adds the clickhandler, the filter and the caleander <br/>
    /// further, it loads the initial content
    /// </summary>
    var me = this;
    try {
        if (me.error) {
            return false;
        }

        me.showInfo("", "", false);
        me.archiveParameter = {
            "datatype": 2,
            "FillNullValues": true,
            "ShowIntervention": false,
            "ShowInvalidValues": true,
            "dateUserDef": false,
            "separateDataAxis": false,
            "ShowPlotLines": true,
            "ShowExportIcons": false,
            "showInterventions": false,
            "UseSimpleBottomLegend": false,
            "Interval": 3,
            "loggerid": this.loggerid
            };
        me.archiveSigParameter = JSON.stringify({
            "series": []
        });
    
        window.VisualCoreService.getData(me.vcvid, me.vcgid, getCurrentTimestamp(), 0, 0, JSON.stringify({ "loggerid": this.loggerid, "timespan":4}), "", me.deviceType, me.langid, "",
            function(result) {
                me.generateMetaList(result);

            });
        return true;
    } catch (ex) {
        me.writeError("MetaOverview.init", ex);
        return false;
    }
};

MetaOverview.prototype.generateMetaList = function (meta) {
    /// <summary>
    /// This function generates the left hand list with the metatypes for selection 
    /// </summary>
    var me = this;
    var row;
    var sTmp = "";
    var mtaaid = -1;
    var first = true;
    try {

        if (me.error) { return false; }
        if (meta.rows && meta.rows.length > 0) {
            for (var i = 0; i < meta.rows.length; i++) {
                if (mtaaid !== meta.rows[i].mtaaid) {
                    if (first === false) {
                        sTmp += "</ul>";
                        //found = false;
                    }
                    sTmp += "<div class='divHeader'>" + meta.rows[i].area + "</div>";
                    mtaaid = meta.rows[i].mtaaid;
                    sTmp += "<ul id='lst-meta" +
                        meta.rows[i].mtaaid +
                        "' data-mtaaid='" +
                        meta.rows[i].mtaaid +
                        "' class='lst-meta'>";
                    first = false;
                }
                row = meta.rows[i];
                sTmp += "<li id='mtid" + row.mtid + "' class='vc-list-item' data-mtid='" + row.mtid + "' >";
                sTmp += "" + row.name + " [" + row.unit + "]";
                sTmp += "</li>";
            }
            if (first === false) {
                sTmp += "</ul>";
            }
            $('#meta-overview-types.vc-list-table').html(sTmp);
            me.visual.find("#meta-overview-types .vc-list-item:odd").addClass("alt");
            me.initClickHandler();
        } else {
            me.showInfo(me.resources.noKeyData, "", false);
            me.visual.find("#meta-overview-types, #meta-overview-chart").hide();

        }
        return true;
    } catch (ex) {  me.writeError('MetaOverview.generateMetaList', ex);
        return false;
    }
};

MetaOverview.prototype.initClickHandler = function () {
    /// <summary>
    /// Initializes the click handler for the left hand list
    /// </summary>
    var me = this;
    var interval,mtaaid;
    try {
        if (me.error) {
            return false;
        }
        // 3 = year meaning monthly parting
        interval = 3;
        //4 = prices
        mtaaid = 4;
        me.visual.find(".vc-list-item").off("click").on("click", function () {
            me.visual.find(".vc-list-item").removeClass("selected");
            $(this).addClass("selected");
            if ($(this).parent().data("mtaaid") !== mtaaid) {
                me.createYearFieldSet("VISUAL_RAMP_DAILY", JSON.stringify({"series": [{ "mtid": [$(this).data("mtid")], "ruletype": 2 }] }), interval);
            } else {
                me.createYearFieldSet("VISUAL_RAMP_MONTHLY", JSON.stringify({"series": [{ "mtid": [$(this).data("mtid")], "ruletype": 2,  "SeriesType": "column"}]}), interval);
            }

        });
        me.visual.find(".vc-list-item:first").trigger("click");
       return true;
    } catch (ex){
        me.writeError("MetaOverview.initClickHandler", ex);
        return false;
    }
};

MetaOverview.prototype.createYearFieldSet = function (chartname, signalParameter, interval) {
    /// <summary>
    /// prepares the fieldsets for the year the overview is going to be
    /// </summary>
    var me = this;
    var years, startDate, endDate, tempArchiveOpt, numYears, chartHeight, chartWidth;
    try {
        if (me.error) {
            return false;
        }
    me.visual.find("#meta-overview-chart").html("");
    years = $("<div>");
    //startYear = endDate.getFullYear() - me.numYears;
    startDate = new Date(me.startYear, 0, 1);
     endDate =new Date(me.startYear, 11, 31);
    tempArchiveOpt = me.archiveParameter;
    tempArchiveOpt.interval = interval;
    tempArchiveOpt.startDate = startDate;
    tempArchiveOpt.endDate = endDate;

    numYears = (me.endYear - me.startYear) +1;
    chartHeight = parseInt(me.height / numYears, 10) -70;
    chartWidth = parseInt(me.visual.find("#meta-overview-chart").width() * 0.99, 10);
    for (var i = me.startYear; i <= me.endYear; i++) {
        years.prepend($("<fieldset class='fieldYear' style='float:both; box-sizing:border-box; height:" + (chartHeight + 30) + "px; margin:0; margin-bottom:10px;  width:100%;' data-year='" + i+ "'><legend>" + i + "</legend></fieldset>"));
        window.VisualCoreService.getVisualContentByName(chartname, i, getCurrentTimestamp(), chartHeight, chartWidth,  JSON.stringify(tempArchiveOpt), signalParameter, 1, function (res) {
            var tmp = $(res);
            years.find(".fieldYear[data-year='" + tmp.attr("id").replace("divVisualcore", "") + "']").append(res);
        });

        startDate = new Date(startDate.getFullYear()+1, 0, 1);
        endDate =new Date(startDate.getFullYear(), 11, 31);
        tempArchiveOpt.startDate = startDate;
        tempArchiveOpt.endDate = endDate;

    }
    me.visual.find("#meta-overview-chart").append(years);
    return true;
} catch (ex) {
    me.writeError("MetaOverview.createYearFieldSet", ex);
    return false;
}
};

MetaOverview.prototype.specificInfoHandling = function (bError) {
    /// <summary>
    /// This function  hides/fades out content on error state. 
    /// </summary>
    var me = this;
    try {
        if (bError) {
            me.visual.find("#meta-overview-types, #meta-overview-chart").hide();
        }
        return true;
    } catch (ex) {
        me.writeError("MetaOverview.specificInfoHandling", ex);
        return false;
    }
};
